module.exports = __webpack_public_path__ + "assets/img/my-vpp-bg-2.6bf56140.png";